import makeStyles from '@material-ui/core/styles/makeStyles';
import {ReactComponent as Coin} from './icon/coin.svg';
export const useStyles = makeStyles(() => ({
    "@global": {
        "@keyframes coin": {
            "0%": {
                bottom: -70
            },
            "20%": {
              fontSize: -50
            },
            "40%": {
                fontSize: -70
            },
            "60%": {
                fontSize: -50
            },
            "80%": {
                fontSize: -70
            },
            "100%": {
              fontSize: -50
            }
          }
    },
    root: {
        borderTop: '1px solid rgba(55, 55, 55, 0.44)', 
        maxWidth: 1167, 
        width: '100%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        margin: '0 auto', 
        padding: '15px 0 42px'
    },
    wrapLeft: {
        display: 'flex', 
        flexDirection: 'column'
    },
    text: {
        color: '#7C5B8D', 
        fontWeight: 'normal', 
        fontSize: 16, 
        fontFamily: 'Circe, sans-serif'
    },
    wrapRight: {
        width: 42, 
        height: 42, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: 'rgba(255, 255, 255, 0.07)', 
        backgroundBlendMode: 'soft-light, normal', 
        backdropFilter: 'blur(9px)', 
        borderRadius: 13
    },
    text18: {
        color: '#FFFFFF', 
        fontWeight: 'normal', 
        fontSize: 16, 
        fontFamily: 'Circe, sans-serif'
    },
    wrapCoin: {
        position: 'absolute', 
        left: '60%', 
        bottom: -70,
        'animation-iteration-count': 'infinite',
        animationDuration: '1s',
        animationDirection: 'alternate',
        animationName: 'size',
    },
    

}))

export {
    Coin
}